import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from "@angular/core";
import { VideoEntryUtils } from "@app/main/components/videos/utils/video-entry-utils";
import { IVeriTag } from "@directives/_veri/v-tags/v-tags.component";
import { ObservationsService } from "@services/observations.service";
import { VideoObservation } from "../../../../components/videos/enums/VideoObservation";
import { IVideoEntry } from "../../../../components/videos/models/IVideoEntry";
import { CameraService } from "../../../../components/videos/services/camera.service";
import "./video-entry.component.scss";

type ThumbnailSourceType = 'direct' | 'channelMedia';

@Component({
    selector: "video-entry",
    template: require("./video-entry.component.html")
})
export class VideoEntryComponent implements OnInit, OnChanges {

    @Input() video: IVideoEntry;
    @Input() showDate: boolean;
    @Input() showVehicle: boolean;
    @Input() compactView: boolean = false;
    @Input() thumbnailSourceType: ThumbnailSourceType = 'channelMedia';

    @Output() onPlayVideo = new EventEmitter<{ videoEntry: IVideoEntry, $event: MouseEvent }>();

    @ViewChild('videoPlayer') videoPlayer: ElementRef<HTMLVideoElement>;

    // ---

    loading: boolean;

    tags: IVeriTag<VideoObservation>[] = [];

    showVideoPreview = false;
    thumbnailSrc = "";

    constructor(
        private readonly observationsService: ObservationsService,
        private readonly cameraService: CameraService) {
    }

    ngOnInit(): void {
        this.thumbnailSrc = this.getThumbnailSrc();
    }

    ngOnChanges(): void {
        this.createTags();
    }

    playVideo(event: MouseEvent): void {
        if (!VideoEntryUtils.isDownloaded(this.video)) {
            return;
        }

        this.onPlayVideo.emit({ videoEntry: this.video, $event: event });
    }

    downloadVideo(): void {
        this.cameraService.downloadVideo(this.video);
    }

    startVideoPreview(): void {
        // Dont allow this to be called twice
        if (this.showVideoPreview) {
            return;
        }

        this.showVideoPreview = true;

        if (!this.videoPlayer) {
            return;
        }

        this.loading = true;

        setTimeout(() => {
            this.videoPlayer.nativeElement.onloadeddata = () => {
                this.videoPlayer.nativeElement.play();
                this.videoPlayer.nativeElement.muted = true;
                this.loading = false;
            };
        });
    }

    endVideoPreview(): void {
        if (this.videoPlayer) {
            this.videoPlayer.nativeElement.src = null;
            this.videoPlayer.nativeElement.onloadeddata = null;
        }

        this.showVideoPreview = false;
        this.loading = false;
    }

    // --- 

    private getThumbnailSrc(): string {
        switch (this.thumbnailSourceType) {
            case 'direct':
                return this.video.thumbnailUrl;
            case 'channelMedia':
                return this.video.channelMedia[0].thumbnailUrl
            default:
                throw new Error("Unsupported thumbnail type");
        }
    }

    private createTags(): void {
        this.tags = [];

        this.video?.MetaData?.VideoObservations?.forEach(videoObservation => {
            if (!VideoObservation[videoObservation]) {
                return;
            }

            this.tags.push({
                id: this.tags?.length,
                label: this.observationsService.setObservationTitleForDisplay(videoObservation)
            });
        });
    }
}
